<div class="row page-header">
    <div class="col-12">
        <h1>SWPPP <small>Stormwater sites, inspections, and weather events</small></h1>
    </div>
</div>

<div [hidden]="isInitialLoading">
    <ul ngbNav [(activeId)]="activeTab" (activeIdChange)="tabChanged()" class="nav-tabs mb-3">
        @if (canViewDashboard) {
            <li [ngbNavItem]="0" [destroyOnHide]="false">
                <a ngbNavLink>Dashboard</a>
            </li>
        }
        <li [ngbNavItem]="1" [destroyOnHide]="false">
            <a ngbNavLink>Sites</a>
        </li>
    </ul>

    @if (canViewDashboard) {
        <div [hidden]="!isDashboardTab">
            <app-swppp-dashboard></app-swppp-dashboard>
        </div>
    }

    <div [hidden]="!isRecordsTab">
        <app-swppp-sites></app-swppp-sites>
    </div>
</div>
